import { formatSelectValue, formatToSelectValue } from '../utils/helpers';
import {
  GYM_MEMBERSHIP_TYPE_OPTIONS,
  GYM_PAYMENT_METHOD_1,
  GYM_PAYMENT_METHOD_2,
  TITLE_TYPE,
  COMPACT_STAKEHOLDER_ROLE,
} from '../utils/enums';
import * as moment from 'moment';

export function specialAccessFields(values?: any) {
  if (!values) {
    values = {};
  }
  return {
    applicantTitleNameSurname: values.applicantTitleNameSurname || '',
    idNumber: values.idNumber || '',
    passportNumber: values.passportNumber || '',
    cellNumber: values.cellNumber || '',
    email: values.email || '',
    vehicleRegNo: values.vehicleRegNo || '',
    vehicleMake: values.vehicleMake || '',
    vehicleModel: values.vehicleModel || '',
    vehicleColour: values.vehicleColour || '',
    mainContractorName: values.mainContractorName || '',
    companyName: values.companyName || '',
    projectStandNumber: values.projectStandNumber || '',
    projectDuration: values.projectDuration || '',
    motivationForSpecialAccess: values.motivationForSpecialAccess || '',
    durationOfSpecialAccess: values.durationOfSpecialAccess || '',
    gallagherRegistered: values.gallagherRegistered || '',
    gallagherRegisteredDate: values.gallagherRegisteredDate || '',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    signedAt: values.signedAt || '',
    signature: values.signature || '',
    signatureDate: values.signatureDate || moment().format('YYYY-MM-DD'),
    contractDocument: values.contractDocument || '',
    identityDocument: values.identityDocument || '',
    vehicleLicence: values.vehicleLicence || '',
  };
}

export function contractorSecurityAccessFields(values?: any) {
  if (!values) {
    values = {};
  }
  return {
    title: formatToSelectValue(values.title, TITLE_TYPE) || '',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    idNumber: values.idNumber || '',
    country: values.country || '',
    passportNumber: values.passportNumber || '',
    dob: values.dob || '',
    cellNumber: values.cellNumber || '',
    email: values.email || '',
    standNumber: values.standNumber || '',
    suburb: values.suburb || '',
    positionHeld: values.positionHeld || '',
    workToBeDone: values.workToBeDone || '',
    accessStartDate: values.accessStartDate || '',
    accessEndDate: values.accessEndDate || '',
    documents: values.documents || [],
    signature: values.signature || '',
    signatureDate: values.signatureDate || '',
    mainContractorCoName: values.mainContractorCoName || '',
    mainContractorCoRegNo: values.mainContractorCoRegNo || '',
    mainContractorTitleNameSurname: values.mainContractorTitleNameSurname || '',
    mainContractorPositionHeld: values.mainContractorPositionHeld || '',
    mainContractorCell: values.mainContractorCell || '',
    mainContractorTelW: values.mainContractorTelW || '',
    mainContractorEmail: values.mainContractorEmail || '',
    mainContractorPhysicalAddress: values.mainContractorPhysicalAddress || '',
    mainContractorCrimcheckDone: values.mainContractorCrimcheckDone || false,
    mainContractorPaymentMade: values.mainContractorPaymentMade || false,
    mainContractorNextOfKin: values.mainContractorNextOfKin || '',
    mainContractorNextOfKinTel: values.mainContractorNextOfKinTel || '',
  };
}

export function crimCheckFields(values?: any) {
  if (!values) {
    values = {};
  }
  return {
    companyName: values.companyName || '',
    email: values.email || '',
    companyAgentName: values.companyAgentName || '',
    cellNumber: values.cellNumber || '',
    surname: values.surname || '',
    fullNames: values.fullNames || '',
    maidenName: values.maidenName || '',
    dob: values.dob || '',
    idNumber: values.idNumber || '',
    descriptionOfIdentifier: values.descriptionOfIdentifier || '',
    physicalAddress: values.physicalAddress || '',
    candidateSignature: values.candidateSignature || '',
    candidateCellNumber: values.candidateCellNumber || '',
    candidateSignatureDate: values.candidateSignatureDate || '',
    companyAgentSignature: values.companyAgentSignature || '',
    companyAgentSignatureDate: values.companyAgentSignatureDate || '',
  };
}

export function subcontractorSecurityAccessFields(values?: any) {
  if (!values) {
    values = {};
  }
  return {
    applicantType: values.applicantType || 'APPLICANT',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    idNumber: values.idNumber || '',
    country: values.country || '',
    cellNumber: values.cellNumber || '',
    email: values.email || '',
    standNumber: values.standNumber || '',
    suburb: values.suburb || '',
    positionHeld: values.positionHeld || '',
    mainContractorCoName: values.mainContractorCoName || '',
    mainContractorCoRegNo: values.mainContractorCoRegNo || '',
    mainContractorTitleNameSurname: values.mainContractorTitleNameSurname || '',
    mainContractorPositionHeld: values.mainContractorPositionHeld || '',
    mainContractorCell: values.mainContractorCell || '',
    mainContractorTelW: values.mainContractorTelW || '',
    mainContractorEmail: values.mainContractorEmail || '',
    mainContractorPhysicalAddress: values.mainContractorPhysicalAddress || '',
    mainContractorCrimcheckDone: values.mainContractorCrimcheckDone || '',
    mainContractorPaymentMade: values.mainContractorPaymentMade || '',
    mainContractorNextOfKin: values.mainContractorNextOfKin || '',
    mainContractorNextOfKinTel: values.mainContractorNextOfKinTel || '',
    workToBeDone: values.workToBeDone || '',
    accessStartDate: values.accessStartDate || '',
    accessEndDate: values.accessEndDate || '',
    subContractorCoName: values.subContractorCoName || '',
    subContractorCoRegNo: values.subContractorCoRegNo || '',
    subContractorTitleNameSurname: values.subContractorTitleNameSurname || '',
    subContractorPositionHeld: values.subContractorPositionHeld || '',
    subContractorCell: values.subContractorCell || '',
    subContractorTelW: values.subContractorTelW || '',
    subContractorEmail: values.subContractorEmail || '',
    subContractorPhysicalAddress: values.subContractorPhysicalAddress || '',
    subContractorCrimcheckDone: values.subContractorCrimcheckDone || false,
    subContractorPaymentMade: values.subContractorPaymentMade || false,
    signature: values.signature || '',
    documents: values.documents || [],
    signatureDate: values.signatureDate || '',
  };
}

export function petApplicationFields(values: any) {
  if (!values) {
    values = {};
  }
  return {
    applicantType: values.applicantType || '',
    title: formatToSelectValue(values.title, TITLE_TYPE) || '',
    date: values.date || '',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    tel: values.tel || '',
    email: values.email || '',
    standNumber: values.standNumber || '',
    suburb: values.suburb || '',
    signature: values.signature || '',
    signatureDate: values.signatureDate || '',
    typeOfPet: values.typeOfPet || '',
    petsName: values.petsName || '',
    breed: values.breed || '',
    description: values.description || '',
    sex: values.sex || '',
    picture: values.picture || '',
    proof: values.proof || '',
  };
}

export function bankDebitOrderInstructionFields(values: any) {
  if (!values) {
    values = {};
  }
  return {
    name: values.name || '',
    address: values.address || '',
    portionErfUnit: values.portionErfUnit || '',
    email: values.email || '',
    contactNo: values.contactNo || '',
    date: values.date || '',
    debitAmount: values.debitAmount || '',
    bank: values.bank || '',
    branchName: values.branchName || '',
    branchNo: values.branchNo || '',
    accountName: values.accountName || '',
    accountNo: values.accountNo || '',
    accountType: values.accountType || '',
    paymentDay: values.paymentDay || '',
    commencementDate: values.commencementDate || '',
    signedAt: values.signedAt || '',
    signedAtDay: values.signedAtDay || '',
    authorisedPersonsNames: values.authorisedPersonsNames || '',
  };
}

export function shuttleServiceFields(values: any) {
  if (!values) {
    values = {};
  }
  const data = {
    authorisedPersonsRole: values.authorisedPersonsRole || '',
    authorisedPersonsTitleNameSurname: values.authorisedPersonsTitleNameSurname || '',
    standNumber: values.standNumber || '',
    suburb: values.suburb || '',
    authorisedPersonsSignature: values.authorisedPersonsSignature || '',
    authorisedPersonsSignatureDate: values.authorisedPersonsSignatureDate || moment().format('YYYY-MM-DD'),
    applicantType: values.applicantType || '',
    applicantTitleNameSurname: values.applicantTitleNameSurname || '',
    applicantSignature: values.applicantSignature || '',
    applicantSignatureDate: values.applicantSignatureDate || moment().format('YYYY-MM-DD'),
  };
  console.log(data);
  return data;
}

export function residentSecurityAccessFields(values: any) {
  if (!values) {
    values = {};
  }
  return {
    applicantType: formatToSelectValue(values.applicantType || values.role, COMPACT_STAKEHOLDER_ROLE) || '',
    title: formatToSelectValue(values.title, TITLE_TYPE) || '',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    idNumber: values.idNumber || '',
    idImage: values.idImage || '',
    country: values.country || '',
    passportNumber: values.passportNumber || '',
    dob: values.dob || '',
    cellNumber: values.cellNumber || '',
    email: values.email || '',
    homeNumber: values.homeNumber || '',
    workNumber: values.workNumber || '',
    standNumber: values.standNumber || '',
    suburb: values.suburb || '',
    nextOfKin: values.nextOfKin || '',
    nextOfKinTel: values.nextOfKinTel || '',
    signature: values.signature || '',
    signatureDate: values.signatureDate || '',
    clickOnVisitorAccessSystem: values.clickOnVisitorAccessSystem || [{ name: '', tel: '' }],
  };
}

export function securityAccessFields(values?: any) {
  if (!values) {
    values = {};
  }
  return {
    applicantType: values.applicantType || '', // RADIO GROUP
    otherSpecify: values.otherSpecify || '',
    title: formatToSelectValue(values.title, TITLE_TYPE) || '',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    idNumber: values.idNumber || '',
    country: values.country || '',
    passportNumber: values.passportNumber || '',
    dob: values.dob || '',
    cellNumber: values.cellNumber || '',
    email: values.email || '',
    homeNumber: values.homeNumber || '',
    workNumber: values.workNumber || '',
    standNumber: values.standNumber || '',
    suburb: values.suburb || '',
    workingDays: values.workingDays || [
      { label: 'Monday', value: false },
      { label: 'Tuesday', value: false },
      { label: 'Wednesday', value: false },
      { label: 'Thursday', value: false },
      { label: 'Friday', value: false },
      { label: 'Saturday', value: false },
      { label: 'Sunday', value: false },
    ],
    liveIn: values.liveIn || false, //  BOOLEAN
    positionHeldAndDivision: values.positionHeldAndDivision || '',
    accessStartDate: values.accessStartDate || '',
    accessEndDate: values.accessEndDate || '',
    responsiblePersonsTitleNameSurname: values.responsiblePersonsTitleNameSurname || '',
    responsiblePersonsCell: values.responsiblePersonsCell || '',
    responsiblePersonsStandNumber: values.responsiblePersonsStandNumber || '',
    responsiblePersonsSuburb: values.responsiblePersonsSuburb || '',
    signature: values.signature || '',
    signatureDate: values.signatureDate || '',
    identityDocument: values.identityDocument || '',
    clickOnVisitorAccessSystem: values.clickOnVisitorAccessSystem || [{ name: '', tel: '' }],
  };
}

export function vehicleSecurityAccessFields(values: any) {
  if (!values) {
    values = {};
  }
  return {
    title: formatToSelectValue(values.title || 'MR', TITLE_TYPE) || '',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    signature: values.signature || '',
    signatureDate: values.signatureDate || '',
    licenseImage: values.licenseImage || '',
    vehicles: values.vehicles || [{
      vehicleMake: '',
      vehicleModel: '',
      vehicleModelYear: '',
      vehicleRegNo: '',
      vehicleColour: '',
      regularDriverTitleNameSurname: '',
      regularDriverRelationship: '',
      licenseDiscImage: '',
    }],
  };
}

export function tennisFormFields(values: any) {
  if (!values) {
    values = {};
  }
  return {
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    parentsNameIfMinor: values.parentsNameIfMinor || '',
    cellNumber: values.cellNumber || '',
    workNumber: values.workNumber || '',
    email: values.email || '',
    nameOfEmergencyContact: values.nameOfEmergencyContact || '',
    telEmergency: values.telEmergency || '',
    medicalConditions: values.medicalConditions || '',
    personResponsibleForAccounts: values.personResponsibleForAccounts || '',
    accountHolder: values.accountHolder || '',
    accountType: values.accountType || '',
    accountNumber: values.accountNumber || '',
    bankName: values.bankName || '',
    branchNameAndCode: values.branchNameAndCode || '',
    totalAmountDeducted: values.totalAmountDeducted || '',
    individualLessonsStandard1Hour: values.individualLessonsStandard1Hour || false,
    individualLessonsStandard30Mins: values.individualLessonsStandard30Mins || false,
    individualRatePerMonthOrLess10Lessons1Hour: values.individualRatePerMonthOrLess10Lessons1Hour || false,
    individualRatePerMonthOrLess10Lessons30Mins: values.individualRatePerMonthOrLess10Lessons30Mins || false,
    semiIndividualLessons1Hour: values.semiIndividualLessons1Hour || false,
    semiIndividualLessons1Hour30mins: values.semiIndividualLessons1Hour30mins || false,
    hittingSession: values.hittingSession || false,
    smallGroup: values.smallGroup || false,
    standardGroup: values.standardGroup || false,
    aerobicTennis: values.aerobicTennis || false,
    squad: values.squad || false,
    signed: values.signed || '',
    date: values.date || '',
  };
}

export function gymMembershipFields(values: any) {
  if (!values) {
    values = {};
  }
  return {
    title: values.title || '',
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    idNumber: values.idNumber || '',
    email: values.email || '',
    cellNumber: values.cellNumber || '',
    workNumber: values.workNumber || '',
    homeNumber: values.homeNumber || '',
    address: values.address || '',
    postalCode: values.postalCode || '',
    bank: values.bank || '',
    titleResponsible: values.titleResponsible || '',
    firstNameResponsible: values.firstNameResponsible || '',
    lastNameResponsible: values.lastNameResponsible || '',
    idNumberResponsible: values.idNumberResponsible || '',
    emailResponsible: values.emailResponsible || '',
    cellNumberResponsible: values.cellNumberResponsible || '',
    workNumberResponsible: values.workNumberResponsible || '',
    homeNumberResponsible: values.homeNumberResponsible || '',
    addressResponsible: values.addressResponsible || '',
    membershipType: formatSelectValue(values.membershipType) || GYM_MEMBERSHIP_TYPE_OPTIONS[0].value,
    paymentMethod: formatSelectValue(values.paymentMethod) || GYM_PAYMENT_METHOD_1[0].value,
    paymentMethod2: formatSelectValue(values.paymentMethod2) || GYM_PAYMENT_METHOD_2[0].value,
    commencementDate: values.commencementDate || '',
    duration: values.duration || '',
    totalAmountDue: values.totalAmountDue || '',
    date: values.date || '',
  };
}



// WEBPACK FOOTER //
// ./src/consts/applicationFormInitializations.ts